module.exports = __webpack_public_path__ + "img/pk.a322af74.svg";